export default {
  name: 'Loading',
  props: {
    message: {
      type: String,
      default: 'Loading...',
    },
  },
};
